import { useEffect } from 'react';

export const useDebouncedEffect = (effect: () => void, deps: Array<unknown> = [], delay: number) => {
    useEffect(() => {
        const handler = setTimeout(() => effect(), delay);

        return () => clearTimeout(handler);
    }, [...deps, delay]);
};
